module.exports = __webpack_public_path__ + "static/img/jdms.5d97d98.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jdms.svg
// module id = Psjw
// module chunks = 2